import { render } from "./Edit.vue?vue&type=template&id=0ff4ca4a"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Courses/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ff4ca4a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ff4ca4a', __exports__)) {
    api.reload('0ff4ca4a', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=0ff4ca4a", () => {
    api.rerender('0ff4ca4a', render)
  })

}


export default __exports__